module.exports = __webpack_public_path__ + "static/media/Test17.0d8a97af.bmp";